export default __webpack_public_path__ + "static/media/health_coach_low.27d5a46e.svg";